import { useCartStore } from '../../../stores/cartStore';
import { useNotificationsStore } from '../../../stores/notificationsStore';
import { initCommerceApiWithGlobals } from 'common-api';
import { cartNotification } from '../../../helpers/cartNotification';
import { logger } from 'common-ui';

export function useActionBatchAddToCart() {
  return async (cartItems: any): Promise<void> => {
    try {
      const commerceApi = initCommerceApiWithGlobals();
      const newCartData = await commerceApi.Cart.batch(cartItems);
      if (newCartData) {
        useCartStore.getState().updateCart(prevState => ({
          ...prevState,
          cartIsLoaded: true,
          cartItems: {
            ...prevState.cartItems,
            ...newCartData,
          },
        }));
        const fallbackItem = cartItems.cartItems[1] || cartItems.cartItems[0] || {};
        const { itemCode, quantity } = fallbackItem;
        const notification = cartNotification(itemCode, quantity);
        useNotificationsStore.setState({ notifications: [notification] });
      }
    } catch (error) {
      logger.error('API ERROR', error);
      throw error;
    }
  };
}
